import { FaLock, FaShieldAlt } from "react-icons/fa";
import { AiOutlineExclamationCircle } from "react-icons/ai";

const CancelButtonModal = ({
  onGoBack,
  onCloseCancelButtonModal,
  title = "Transaction Guard",
  message = (
    <>
      You are about to interrupt a{" "}
      <span className="font-bold text-[#DE554D]">secure payment session</span>
      . Any progress will be permanently lost.
    </>
  ),
  primaryLabel = "Keep Protecting My Payment",
  secondaryLabel = "Stop & Exit Anyway",
}) => {
  return (
    <>
      {/* Premium Frosted Overlay */}
      <div
        className="fixed inset-0 flex items-center justify-center p-4 z-[9999]"
        style={{
          backgroundColor: "rgba(10, 25, 60, 0.45)",
          backdropFilter: "blur(6px)"
        }}
      >
        {/* Glassmorphism Card */}
        <div
          className="w-full max-w-[340px] bg-white rounded-[28px] shadow-2xl flex flex-col overflow-hidden"
          style={{
            animation: "swink-fade-up 0.4s cubic-bezier(0.22, 1, 0.36, 1) both",
            border: "1px solid rgba(255, 255, 255, 0.8)"
          }}
        >
          {/* Header Accent (Red for danger) */}
          <div className="h-1.5 w-full bg-gradient-to-r from-[#DE554D] to-[#c8403a]" />

          <div className="px-6 pt-8 pb-7 flex flex-col items-center">
            {/* Animated Shield/Warning Icon */}
            <div className="relative mb-6">
              <style>{`
                @keyframes warning-pulse {
                  0% { transform: scale(1); opacity: 0.8; }
                  50% { transform: scale(1.1); opacity: 0.4; }
                  100% { transform: scale(1); opacity: 0.8; }
                }
                .guard-glow {
                  position: absolute;
                  inset: -8px;
                  background: rgba(222, 85, 77, 0.15);
                  border-radius: 50%;
                  animation: warning-pulse 2s ease-in-out infinite;
                }
                @keyframes swink-fade-up {
                  from { opacity: 0; transform: translateY(20px); }
                  to { opacity: 1; transform: translateY(0); }
                }
              `}</style>
              <div className="guard-glow" />
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center relative z-10"
                style={{
                  background: "linear-gradient(135deg, #DE554D 0%, #c8403a 100%)",
                  boxShadow: "0 8px 20px rgba(222, 85, 77, 0.3)"
                }}
              >
                <FaShieldAlt className="text-white text-3xl" />
                <AiOutlineExclamationCircle
                  className="absolute text-white text-lg"
                  style={{ bottom: 12, right: 12, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))" }}
                />
              </div>
            </div>

            {/* Content */}
            <h3 className="text-xl font-extrabold text-[#1a2d5a] mb-2 text-center leading-tight">
              {title}
            </h3>
            <p className="text-[13px] text-gray-500 text-center leading-relaxed mb-8 px-2">
              {message}
            </p>

            {/* Action Stack */}
            <div className="w-full flex flex-col gap-3">
              <button
                className="w-full py-3.5 rounded-2xl text-white text-sm font-bold transition-all duration-200 active:scale-[0.97]"
                style={{
                  background: "linear-gradient(135deg, #1E56C8 0%, #1340A0 100%)",
                  boxShadow: "0 4px 12px rgba(30, 86, 200, 0.25)"
                }}
                type="button"
                onClick={onCloseCancelButtonModal}
              >
                {primaryLabel}
              </button>

              <button
                className="w-full py-3 rounded-2xl text-[#DE554D] text-xs font-bold transition-all duration-200 hover:bg-red-50"
                type="button"
                onClick={onGoBack}
              >
                {secondaryLabel}
              </button>
            </div>
          </div>

          {/* Trust Footer */}
          <div className="bg-gray-50/80 py-3.5 border-t border-gray-100 flex items-center justify-center gap-1.5">
            <FaLock className="text-[#1E56C8] text-[10px]" />
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
              Secured by SwinkPay Guard
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancelButtonModal;
